import * as React from 'react'
import { Link } from 'react-router-dom'

interface Props {
}

export default class ContactComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		return (
			<div className="section" id="contacts-before">
				<div className="row">
					<div className="container">
						<div className="col-xs-12 col-sm-12 section-title-en">
							CONTACT
						</div>
						<div className="col-xs-12 col-sm-12 section-title-ja">
							まずは、カジュアルにご相談ください。
						</div>
						<div className="col-xs-12 col-sm-12 conversion">
							<Link to="/contacts" className="conversion-button">相談してみる（無料）</Link>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/common/contactComponent.tsx